import { Box, Typography, TextField, Button, Rating, Stepper, Step, StepLabel, styled, FormControl, FormControlLabel, RadioGroup, Radio} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import * as api from '../services/api'
import styles from './healthAss.module.css'
import back from '../../assets/icons/back.svg';
import { useDispatch, useSelector } from 'react-redux';
import { user_data } from '../../store/authSlice';
import { menuActive } from '../../store/menuSlice';
import dayjs from 'dayjs'
import Loader from '../../components/Loader';
import CircleIcon from '@mui/icons-material/Circle';
import { withStyles } from '@mui/styles';
import moment from 'moment';
import CustomizedModal from '../../components/modal/CustomizedModal';
import InsertBar from '../../components/InsertBar';
import { useFormState } from 'react-dom';

function AssessmentDetail() {
  const auth = useSelector((state) => state.auth.user_data)
  
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [steps,setSteps] = useState([]);
  const [form,setForm] = useState({});
  const [result,setResult] = useState({
    "evaluate_date": dayjs().format('YYYY-MM-DD'),
    "pid": auth['card_id'],
     "title_name": auth['titlename'],
    "firstname": auth['firstname'],
    "lastname": auth["lastname"],
    "gender": auth["gender"],
    "department": auth['department']['department_name_short']
  });
  const [answerPaper, setAnswerPaper] = useState({})
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [prevQuestion, setPrevQuestion] = useState(1);
  const [data, setData] = useState({});
  const handleCloseCancelModal = () => setShowCancelModal(false);
  const [allForm, setAllForm] = useState({});
  const [skip, setSkip] = useState(false);
  const [nextQuestion,setNextQuestion] = useState(1)

  useEffect(() => {
    dispatch(menuActive('แบบประเมินสุขภาพ'))
    fetchFormDetail(location.state.evaluation_code)

  }, [])

  const fetchFormDetail = async (search) => {
      setLoading(true);
      const res = await api.findFormEvaluation(search);
      setLoading(false);
  
      if (res) {
          if (res['data']['code'] === 200) {
              const detail = res['data']['data'][0];
  
              // Ensure forms is always an array
              const forms = detail["evaluation_section"] || [];
              // forms.forEach(form => {
              //   form.interpret = form.interpret || [];
              // });
  
              setData({ 
                ...data,
                  code: detail["evaluation_code"],
                  title: detail["evaluation_name"], 
                  remark: detail["evaluation_detail"],
                  image: detail["evaluation_image"],  
                  forms: forms, // Use the ensured array
                  part: detail["evaluation_section_total"] // Set part to 1 if forms is empty/null
              });
  
              
              setSteps(forms.map(section => section.line_number))
              setForm(forms[location.state.button - 1])
              setAllForm(forms);
          } else {
              handleError(res['data']['message']);
              navigate('/assessment');
          }
      } else {
          handleError("ไม่ตอบสนอง");
      }
  };

  useEffect(() => {
  if (data.part > 0) {
    createResultForm();
    createAnswerPaper();
  }
}, [data.forms]);

const createResultForm = () => {
  let form = { ...result }; // or start with empty: let form = {};
  for (let i = 0; i < data.part; i++) {
    form[data.forms[i].topic] = [];

    for (let j = 0; j < data.forms[i].forms.length; j++){
      let quiz = data.forms[i].forms[j];
      let quiz_result = {}
      if (quiz.question_type === "คำตอบสั้น ๆ (ไม่มีการแปลผล)") {
        quiz_result = {
        "question": quiz.question,
        "answer": ""
        }
      } else if (quiz.question_type === "หลายตัวเลือก") {
        quiz_result = {
        "question": quiz.question,
        "answer": "",
        "score": null
        }
      }  else {
        quiz_result = {
        "question": quiz.question,
        "score": null
        }
      }
      
      form[data.forms[i].topic].push(quiz_result)
    }
  }
  setResult(form);
};

const createAnswerPaper = () => {
  let form = { ...answerPaper }; // or start with empty: let form = {};
  for (let i = 0; i < data.part; i++) {
    form[data.forms[i].topic] = [];

    for (let j = 0; j < data.forms[i].forms.length; j++){
      let quiz_result = {};
      if (data.forms[i].forms[j].question_type === "หลายตัวเลือก") {
       quiz_result = {
        "answer": "",
        to: ""
        }
      } else {
        quiz_result = {
          "answer": ""
        }
      }
      form[data.forms[i].topic].push(quiz_result)
    }
  }
  setAnswerPaper(form);
};
  
  const confirmCancelChanges = () => {
    setShowCancelModal(false);
    navigate('/assessment'); 
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleButton = (number) => {
    navigate('.', { state: { button: number, evaluation_code: location.state.evaluation_code, } , replace: true });
    setForm(data.forms[number - 1])
  };


  const doneAssessment = () => {

    for (let i = 0; i < allForm.length; i++) {
      let current = allForm[i].topic
      const res = result[current]
      let cur_score = 0;
      for (let j = 0; j < res.length; j++) {
        if (allForm[i].forms[j].question_type !== 'คำตอบสั้น ๆ (ไม่มีการแปลผล)') {
          cur_score+=res[j].score
        }
      }
      
      for (let k = 0; k < allForm[i].interpret.length; k++) {
        if ((allForm[i].interpret[k].score_from) <= cur_score &&  
            (allForm[i].interpret[k].score_to) >= cur_score) {
              // add interpret
              result[current]["interpret"] = allForm[i].interpret[k].recommend
            }
      }
      
    }

    
    let inform = {
      "evaluation_date": dayjs().format('YYYY-MM-DD'),
      "fullname": `${auth['titlename']}${auth['firstname']} ${auth['lastname']}`,
      "sex": auth['gender'],
      "birthday": auth['dob'],
      "pid": auth['card_id'],
      "department": auth['department']['department_name'],
      "phone": auth['phone'],
      "result": result,
    }

    saveAssessment(inform)
  }

  const saveAssessment = async (form) => {
    setLoading(true)
    let res = await api.saveAssessment(data['code'], form)
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {        
        navigate('/assessmentResultDetail', {
        state: {
          doc_number: res['data']['data']['doc_number'],
          evaluation_code: data['code'],
        }});
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const convertDate = (dataDate) => {
    const date = new Date(dataDate)
    const optionDate = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    const thaiLocale = 'th-TH';
    const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

    const newDate = `${formattedDate}`
    return newDate
  }

  const handleCloseErrorModal = () => setErrorMessage(null);

  return (
    
    <>
      {/* Cancel Modal */}
        {showCancelModal && (
            <CustomizedModal
            onClose={handleCloseCancelModal}
            apiCall={confirmCancelChanges}
            confirmMessage="คุณต้องการยกเลิกการทำแบบประเมินนี้ หรือไม่?"
            confirmButtonText="ยกเลิก"
            />
        )}
      {/* Error Modal */}
          {errorMessage && (
              <CustomizedModal
              onClose={handleCloseErrorModal}
              confirmMessage={errorMessage}
              apiCall={handleCloseErrorModal}
              confirmButtonText="ตกลง"
              />
          )}


      <Loader loading={loading} />
      <Box sx={{ display: 'grid', gridGap: '10px' }}>
        {/* Back Button */}
        <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { setShowCancelModal(true) }}>
          <img src={back} alt="Previous" className={styles.directIcon} />
          กลับไปหน้า แบบประเมินทั้งหมด
      </Box>


        <Box
          sx={{
            fontWeight: 600,
            color: "#478F96",
            "@media (max-width: 800px)": {
              textAlign: "center",
            },
          }}
        >
          {data['title']}
        </Box>

        {location.state.button > 1 ? 
        <Box sx={{ display: "flex", marginTop: "10px 0" }}>
              {/* Back Button */}
              <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { handleButton(location.state.button - 1) }}>
                    <img src={back} alt="Previous" className={styles.directIcon} />
                    ย้อนกลับ
              </Box>
        </Box> 
        : <Box height='44px'></Box>
        }

        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
          <Stepper
                alternativeLabel
                activeStep={location.state.button - 1}
                sx={{
                  width: '380px',
                  '& .MuiStepConnector-line': {
                    borderStyle: 'dashed',
                    borderWidth: 1,
                    marginLeft: '18px',
                    marginRight: '18px'
                  },
                  '& .MuiStepLabel-root .MuiStepIcon-root': {
                      color: 'transparent',
                      border: '0.5px solid #478F96',
                      borderRadius: '20px',
                      scale:'200%',
                  },
                  '& .MuiStepLabel-root .MuiStepIcon-text': {
                      fill: '#478F96', 
                      fontSize: '8px',
                      fontWeight: 600
                  },
                  '& .MuiStepLabel-root .Mui-active': {
                      color: '#478F96',
                      border: '0px',
                  },    
                  '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                      fill: '#ffffff'
                  }, 
                  '& .MuiStepLabel-label': {
                      display: 'none',
                  },
                  '& .MuiStepLabel-root .Mui-completed': {
                      fill: '#478F96'
                  }, 
                }}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
        </Box>
      
        
        <Box>
            <Box
              sx={{
                display: "grid",
                gridGap: "20px",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  fontWeight: 600,
                  "@media (max-width: 800px)": {
                    fontSize: "14px",
                  },
                }}
              >
                ส่วนที่ {form['line_number']} : {form['topic']}
              </Box>
              <Box sx={{ margin: "0 20px" }}>
                <Typography
                  sx={{
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                    },
                  }}
                >
                  {form['topic_detail']}
                </Typography>
              </Box>

              <Box
                sx={{
                  border: "1px solid #AEB4DD",
                  borderRadius: "5px",
                  padding: "20px",
                }}
              >
                {form['forms']?.map((quiz, quizIndex) => {
                  const firstQuestion = form.forms.find(q => q.question_type === "หลายตัวเลือก")?.question_number;
                  switch(quiz.question_type) {
                      case 'หลายตัวเลือก':
                        return (
                          <MultipleChoiceField
                          key = {quizIndex}
                          quizKey = {quizIndex}
                          topic = {form['topic']}
                          setResult = {setResult}
                          result = {result}
                          quiz = {quiz}
                          last = {quiz.question_number === form['forms'].length}
                          answerPaper={answerPaper}
                          setAnswerPaper={setAnswerPaper}
                          prevQuestion={prevQuestion}
                          form = {form['forms']}
                          setPrevQuestion={setPrevQuestion}
                          firstQuestion = {firstQuestion}
                          nextQuestion={nextQuestion}
                          setNextQuestion = {setNextQuestion}
                          setSkip = {setSkip}
                          skip = {skip}
                          />
                        )
                      case 'คำตอบสั้น ๆ (ไม่มีการแปลผล)':
                          return (
                              <ShortAnswerField
                              key = {quizIndex}
                              quizKey = {quizIndex}
                              quiz = {quiz}
                              topic = {form['topic']}
                              setResult = {setResult}
                              result = {result}
                              last = {quiz.question_number === form['forms'].length}
                              nextQuestion={nextQuestion}
                              setNextQuestion = {setNextQuestion}
                              skip = {skip}
                              />
                          )
                      case 'สเกลเชิงเส้น (ระดับ)':
                          return (
                              <RatioField
                              key = {quizIndex}
                              quiz = {quiz}
                              quizKey = {quizIndex}
                              topic = {form['topic']}
                              setResult = {setResult}
                              result = {result}
                              last = {quiz.question_number === form['forms'].length}
                              answerPaper={answerPaper}
                              setAnswerPaper={setAnswerPaper}
                              />
                          )
                      default:
                          return null;
                  }
                })} 
              </Box>

              
              <Box
                sx={{
                  textAlign: "center",
                }}
              >
                {location.state.button < steps.length ? (
                  <Button
                    variant="contained"
                    sx={{
                      width: "150px",
                      "@media (max-width: 800px)": {
                        width: "100px",
                      },
                    }}
                    onClick={() => {
                      const part_form = form.forms
                      for (let i = 0; i < part_form.length; i++) {
                        const res = result[form.topic]
                        if(part_form[i]['question_type'] === "คำตอบสั้น ๆ (ไม่มีการแปลผล)") {
                          if (res[i].answer === "") {return handleError('กรุณาทำแบบประเมินข้อที่ '+(i+1))}
                          // for (let j = i; j < res.length; j++) {
                          //   if (res[i].answer === "") {return handleError('กรุณาทำแบบประเมินข้อที่ '+(j+1))}
                          // }
                        } 
                        else if(part_form[i]['question_type'] === "สเกลเชิงเส้น (ระดับ)") {
                          if (res[i].score === null) {return handleError('กรุณาทำแบบประเมินข้อที่ '+(i+1))}
                          // for (let j = 0; j < res.length; j++) {
                          //   if (res[j].score === null) {return handleError('กรุณาทำแบบประเมินข้อที่ '+(j+1))}
                          // }
                        } else {
                          if(res[i].answer === '') {return handleError('กรุณาทำแบบประเมินข้อที่ '+(i+1))}
                          // const res = answerPaper[form.topic]
                          // let next = 0
                          // for (let j = 0; j < res.length; j++) {
                          //   if (part_form[j].question_type === 'หลายตัวเลือก') {
                          //   if(res[j].answer === '') {return handleError('กรุณาทำแบบประเมินข้อที่ '+(j+1))}
                          //   else if (next === (j+1) && res[j].answer === '') {
                          //     return handleError('กรุณาทำแบบประเมินข้อที่ '+(j+1))
                          //   }
                          //   else if (res[j].answer !== '') { 
                          //     next = res[j].to
                          //   }
                          // }
                          // }
                        }
                      }
                      handleButton(location.state.button + 1);
                      setSkip(false)
                    }}
                  >
                    ถัดไป
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    sx={{
                      width: "150px",
                      "@media (max-width: 800px)": {
                        width: "100px",
                      },
                    }}
                    onClick={() => {
                      const part_form = form.forms
                      for (let i = 0; i < part_form.length; i++) {
                        const res = result[form.topic]
                        if(part_form[i]['question_type'] === "คำตอบสั้น ๆ (ไม่มีการแปลผล)" || part_form[i]['question_type'] === "หลายตัวเลือก") {
                          if (res[i].answer === "") {return handleError('กรุณาทำแบบประเมินข้อที่ '+(i+1))}
                        } 
                        else if(part_form[i]['question_type'] === "สเกลเชิงเส้น (ระดับ)") {
                          if (res[i].score === null) {return handleError('กรุณาทำแบบประเมินข้อที่ '+(i+1))}
                        }
                    }
                      doneAssessment();
                    }}
                  >
                    บันทึก
                  </Button>
                )}
              </Box>
              
            </Box>

          
        </Box>
      </Box>
    </>
  )
}
export default AssessmentDetail;

function MultipleChoiceField( {quizKey, quiz, topic, setResult, result, last, 
  answerPaper, setAnswerPaper, prevQuestion, setPrevQuestion, form, firstQuestion, nextQuestion, setNextQuestion, setSkip, skip} ) {
     const questionIndex = quiz['question_number'] - 1;

    return (
      <Box
          key = {quizKey}
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr",
            rowGap: "10px"
          }}
        >
          {/* {quiz.question_number === firstQuestion || answerPaper?.[topic]?.[prevQuestion]?.["to"] === quiz.question_number ||
          answerPaper?.[topic]?.[questionIndex-1]?.["to"] === quiz.question_number || answerPaper?.[topic]?.[questionIndex]?.["answer"] !== '' ||
         form[questionIndex - 1]['question_type'] !== 'หลายตัวเลือก'? */}
         {quiz.question_number === firstQuestion || nextQuestion === quiz.question_number 
         || answerPaper?.[topic]?.[questionIndex]?.["answer"] !== '' ?
          <Box>
            <Typography sx={{ fontWeight: 600 }}>{quiz['question_number']}) {quiz['question']}</Typography>
            <FormControl sx={{ marginLeft: '20px' }}>
              <RadioGroup
                value={answerPaper?.[topic]?.[questionIndex]?.answer ?? ''}
                onChange={(e) => {
                  const newResult = { ...result };
                  const newAnswerPaper = {...answerPaper}

                  // Update the score inside the correct topic array
                  newResult[topic][questionIndex] = {
                    ...newResult[topic][questionIndex],
                    answer:quiz['answer'][e.target.value]['name'],
                    score: quiz['answer'][e.target.value]['value'],
                  };

                  newAnswerPaper[topic][questionIndex] = {
                    ...newAnswerPaper[topic][questionIndex],
                    answer: Number(e.target.value)
                  };

                  const toQuestion = form[quiz.question_number-1]['answer'][e.target.value]['to'];
                  const tempTo = newAnswerPaper[topic][quiz.question_number-1]['to']


                  
                  if (!last || toQuestion !== "nextSec") {
                    if (toQuestion !== "nextSec") {
                      const nextQ = toQuestion === "null" ? quiz.question_number+1 : Number(toQuestion);
                      if (skip) {
                        for (let i = questionIndex + 1; i < form.length; i++) {
                          if (form[i]['question_type'] === 'หลายตัวเลือก') {
                          newResult[topic][i] = {
                          ...newResult[topic][i],
                          answer: "",
                          score: 0
                        }
                      }
                         else if (form[i]['question_type'] === 'คำตอบสั้น ๆ (ไม่มีการแปลผล)') {
                            newResult[topic][i] = {
                            ...newResult[topic][i],
                            answer: "",
                            }
                          }
                        }
                        setResult(newResult)
                      }

                      setNextQuestion(nextQ);
                      setSkip(false)

                      newAnswerPaper[topic][questionIndex] = {
                        ...newAnswerPaper[topic][questionIndex],
                        to: nextQ
                      };
                        setPrevQuestion(quiz.question_number-1);
                      }
                      else {
                      setNextQuestion(quiz.question_number);
                      setSkip(true)
                    }
                    }


                  for (let i = questionIndex + 1; i < form.length; i++) {
                    // if ((form[i]['question_number'] === tempTo && toQuestion !== "null") || (form[i]['question_number'] < toQuestion && result[topic][i]) || toQuestion === "nextSec") {
                      if ((form[i]['question_number'] < toQuestion && result[topic][i]) || toQuestion === "nextSec") {
                      if (form[i]['question_type'] === 'หลายตัวเลือก') {
                          newResult[topic][i] = {
                          ...newResult[topic][i],
                          answer: "-",
                          score: 0
                        }
                        newAnswerPaper[topic][i] = {
                          answer: "",
                          to:""
                        }
                      }
                      else if (form[i]['question_type'] === 'คำตอบสั้น ๆ (ไม่มีการแปลผล)') {
                          newResult[topic][i] = {
                          ...newResult[topic][i],
                          answer: "-",
                        }
                      }
                      // else if (form[i]['question_type'] === 'สเกลเชิงเส้น (ระดับ)') {
                      //     newResult[topic][i] = {
                      //     ...newResult[topic][i],
                      //     score: 0,
                      //   }
                      // }
                  } 
                }
                  setResult(newResult);
                  setAnswerPaper(newAnswerPaper)

                }}
              >
                {quiz['answer'].map((answer, answerIndex)=> (
                  <FormControlLabel value={answerIndex} control={<Radio />} label={answer.name} key={`${quizKey}-${quiz.question_number}-${answerIndex}`}/>
                ))}
              </RadioGroup>

            </FormControl>
          </Box>
          :
          <Box>
            <Typography sx={{ fontWeight: 600, color: '#bdbdbd' }}>{quiz['question_number']}) {quiz['question']}</Typography>
            <FormControl sx={{ marginLeft: '20px' }}>
              <RadioGroup
              value={''}>
                {quiz['answer'].map((answer, answerIndex)=> (
                  <FormControlLabel disabled value={answerIndex} control={<Radio />} label={answer.name} key={`${quizKey}-${quiz.question_number}-${answerIndex}`}/>
                ))}
              </RadioGroup>

            </FormControl>
          </Box>
            }
          {last? <></>:
          <Box sx={{ borderTop: '1px solid #D9D9D9', marginBottom: '10px' }}></Box>
          }
      </Box>
    )
}

function ShortAnswerField({quiz, quizKey, topic, setResult, result, nextQuestion, setNextQuestion, skip} ) {
    const questionIndex = quiz['question_number'] - 1;
    return (
       <Box
          key = {quizKey}
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gridGap: "10px"
          }}
        >
          {quiz['question_number'] === 1 || (!skip && quiz['question_number'] <= nextQuestion ) ? 
            <Box>
              <Typography sx={{ fontWeight: 600 }}>{quiz['question_number']}) {quiz['question']}</Typography>
              <FormControl sx={{ marginLeft: '20px', marginRight: '20px', width: '96%'  }}>
                <InsertBar
                currentValue={result?.[topic]?.[questionIndex]?.answer ?? ''}
                setNewValue={(e) => { 
                  const newResult = { ...result };

                    // Update the score inside the correct topic array
                    newResult[topic][questionIndex] = {
                      ...newResult[topic][questionIndex],
                      answer: e,
                    };

                    setResult(newResult);
                    setNextQuestion(quiz['question_number']+1)
                    }}
                placeholder="พิมพ์คำตอบที่นี่"
                />
                
              </FormControl>
            </Box>
          
        :
        <Box>
            <Typography sx={{ fontWeight: 600, color: '#bdbdbd' }}>{quiz['question_number']}) {quiz['question']}</Typography>
            <FormControl sx={{ marginLeft: '20px', marginRight: '20px', width: '96%'  }}>
              <InsertBar
              disabled = {true}
              currentValue={''}
              placeholder="พิมพ์คำตอบที่นี่"
              />
              
            </FormControl>
          </Box>}
      </Box>
    )
  }

  function RatioField({quiz, quizKey, topic, setResult, result, last, 
  answerPaper, setAnswerPaper}) {
    let answer = quiz.answer
    const startName = answer[0].name;
    const endName = answer[1].name;
    const startScale = answer[0].value
    const endScale = answer[1].value;
    const range = endScale - startScale + 1;
    const questionIndex = quiz['question_number'] - 1;
  
    return (
      <Box>
      <Box
      key = {quizKey}
      sx={{
            display: "grid",
            gridGap: "20px",
      }}
      >
        <Typography
          sx={{
            display: "flex",
            fontWeight: 600,
            "@media (max-width: 800px)": {
              fontSize: "12px",
            },
            justifyContent: "center",
          }}
        >{quiz['question_number']}) {quiz['question']}</Typography>
        <Box
          sx={{
        display: "flex",
        alignItems: "center",
        gridGap: "20px",
        justifyContent: "center",
        flexWrap: "wrap", // Helps prevent overflow on small screens
        "@media (max-width: 800px)": {
          fontSize: "12px",
          gridGap: "10px", // Reduce gap if needed
        },
      }}
        >
          <Box>{startName}</Box>
          <StyledRating
            name="customized-color"
            max={range}
            icon={<CircleIcon fontSize="small" />}
            emptyIcon={<CircleIcon fontSize="small" />}
            highlightSelectedOnly
            value={Number(answerPaper?.[topic]?.[questionIndex]?.answer) ?? 0}
            onChange={(event, newValue) => {
              let score = newValue-1 + Number(startScale)
              const newResult = { ...result };
                  const newAnswerPaper = {...answerPaper}

                  // Update the score inside the correct topic array
                  newResult[topic][questionIndex] = {
                    ...newResult[topic][questionIndex],
                    score: score,
                  };

                  newAnswerPaper[topic][questionIndex] = {
                    ...newAnswerPaper[topic][questionIndex],
                    answer: newValue,
                  };

                  setResult(newResult);
                  setAnswerPaper(newAnswerPaper)
            }}
          />
          <Box>{endName}</Box>
        </Box>
      </Box>

      {last? <></>:
          <Box width= '93%' sx={{ borderTop: '1px solid #D9D9D9', margin: '20px auto' }}></Box>
          }
      </Box>
    )
  }

const StyledRating = withStyles({
  iconFilled: {
    color: "#478F96",
  },
  iconHover: {
    color: "#478F96",
  },
})(Rating);
